import { Component } from "@angular/core";
import { AuthService } from "./auth/auth.service";
import { RegionService } from "./services/region.service";
import { UserService } from "./services/user.service";
import { ICONS } from "src/icons";
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { filter, switchMap } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DemoNewsService } from "./services/demo-news.service";
import { MaintenanceService } from "./services/maintenance.service";

@Component({
  selector: "brd-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.less"]
})
export class AppComponent {
  loading: boolean = false;

  constructor(
    private authService: AuthService,
    readonly userService: UserService,
    private regionService: RegionService,
    private newsService: DemoNewsService,
    private maintenanceService: MaintenanceService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    ICONS.forEach(icon => {
      iconRegistry.addSvgIcon(icon.name, sanitizer.bypassSecurityTrustResourceUrl(icon.path));
    });
    this.loading = true;
    // Authenticate first so interceptor/guards don't trigger loops while the app is booting.
    this.authService
      .setLoggedUser()
      .pipe(
        takeUntilDestroyed(),
        switchMap(() => this.userService.userInfo$),
        filter(user => !!user),
        switchMap(() => {
          this.loading = false;
          return this.regionService.getRegion();
        }),
        switchMap(() => this.maintenanceService.getMaintenance()),
        switchMap(() => this.newsService.getNewsToRead())
      )
      .subscribe();
  }
}
